"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeDepGraph = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
const subprocess_1 = require("./subprocess");
const path = require("path");
async function computeDepGraph(root, targetFile, additionalArgs) {
    try {
        const defaultArgs = [
            'package',
            '--package-path',
            path.dirname(targetFile),
            'show-dependencies',
            '--format',
            'json',
        ];
        const args = additionalArgs
            ? defaultArgs.concat(additionalArgs)
            : defaultArgs;
        const result = await (0, subprocess_1.execute)('swift', args, { cwd: root });
        const depTree = JSON.parse(result);
        const depGraph = convertToGraph(depTree);
        return depGraph;
    }
    catch (e) {
        throw new Error('Unable to generate dependencies tree');
    }
}
exports.computeDepGraph = computeDepGraph;
function traverseTree(rootNode, builder, rootNodeId) {
    const childNodes = rootNode.dependencies;
    childNodes === null || childNodes === void 0 ? void 0 : childNodes.forEach((node) => {
        const { url, version } = node;
        const name = url
            .replace(/https:\/\//g, '')
            .replace(/http:\/\//g, '')
            .replace(/.git/g, '');
        const parentName = rootNodeId ||
            rootNode.url
                .replace(/https:\/\//g, '')
                .replace(/http:\/\//g, '')
                .replace(/.git/g, '');
        const nodeId = `${name}@${version}`;
        const parentNodeId = `${parentName}@${rootNode.version}`;
        builder.addPkgNode({ name, version }, nodeId);
        builder.connectDep(rootNodeId || parentNodeId, nodeId);
        traverseTree(node, builder);
    });
}
function convertToGraph(rootNode) {
    const { name, version } = rootNode;
    const depGraphBuilder = new dep_graph_1.DepGraphBuilder({ name: 'swift' }, { name, version });
    traverseTree(rootNode, depGraphBuilder, depGraphBuilder.rootNodeId);
    return depGraphBuilder.build();
}
//# sourceMappingURL=compute-depgraph.js.map